// Shared date helpers for the festival pages.
//
// Festival dates arrive in mixed formats: ISO (YYYY-MM-DD) from the admin date
// pickers, and free-form text for deadlines entered by hand. Every helper here
// tolerates both and never renders "Invalid Date".

// Parse date string as local date (not UTC) to prevent timezone shift
export const parseLocalDate = (dateStr) => {
  if (!dateStr) return new Date();
  // If it's just a date string (YYYY-MM-DD), parse as local
  if (dateStr.length === 10 && dateStr.includes('-')) {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  // Strip ordinal suffixes ("October 20th, 2026") — Date can't parse them
  return new Date(dateStr.replace(/\b(\d{1,2})(st|nd|rd|th)\b/gi, '$1'));
};

const format = (dateStr, options) => {
  if (!dateStr) return "";
  const date = parseLocalDate(dateStr);
  // Free-form value like "Rolling" — show it as typed rather than "Invalid Date"
  if (isNaN(date.getTime())) return dateStr;
  return date.toLocaleDateString('en-US', options);
};

// "Oct 20, 2026" — compact, for list views
export const formatDate = (dateStr) =>
  format(dateStr, { month: 'short', day: 'numeric', year: 'numeric' });

// "October 20, 2026" — full month name, for detail pages. Month names are used
// throughout instead of numeric dates, which read ambiguously across regions.
export const formatDateLong = (dateStr) =>
  format(dateStr, { month: 'long', day: 'numeric', year: 'numeric' });

// Format date range (handles single day festivals)
export const formatDateRange = (startDate, endDate, fmt = formatDate) => {
  const start = fmt(startDate);
  if (!endDate || startDate === endDate) {
    return start;
  }
  return `${start} - ${fmt(endDate)}`;
};
